import * as ACTION_TYPES from '@stores/actions/action_types'
import { getHost } from '@utils/appBridge'

function normalizeWhoamiFlags<T extends Record<string, unknown>>(data: T): T {
  const v = data.bulk_download_separate_pdfs
  const bulk =
    v === true || v === 'true' || v === 1 || v === '1' ? true : false
  return { ...data, bulk_download_separate_pdfs: bulk } as T
}
export const remove_logo = (is_remove_logo: boolean) => {
  return {
    type: ACTION_TYPES.REMOVE_LOGO,
    remove_logo: is_remove_logo,
  }
}
export const upload_logo_success = (data: A) => {
  return {
    type: ACTION_TYPES.UPLOAD_LOGO_SUCCESS,
    ...data,
  }
}
export const upload_logo_loading = () => {
  return {
    type: ACTION_TYPES.UPLOAD_LOGO,
  }
}
export const get_shop = (shop: A) => {
  let currentData = shop
  try {
    const oldeData = localStorage.getItem('whoami')
    if (oldeData) {
      const parsedOldData = JSON.parse(oldeData)
      currentData = { ...parsedOldData, ...shop }
    }
    localStorage.setItem('whoami', JSON.stringify(currentData))
  } catch (_e) {
    localStorage.setItem('whoami', JSON.stringify(shop))
  }
  return {
    type: ACTION_TYPES.GET_SHOP,
    shop: currentData,
    payload: currentData,
  }
}
export const set_shop = (shop: A) => {
  let currentData = shop as Record<string, unknown>
  try {
    const oldeData = localStorage.getItem('whoami')
    if (oldeData) {
      const parsedOldData = JSON.parse(oldeData) as Record<string, unknown>
      const host = getHost()
      const queryString = host
        ? {
            query_string: `shop=${currentData.shopify_domain}&host=${host}&embedded=1`,
          }
        : {}
      currentData = {
        ...parsedOldData,
        ...currentData,
        ...queryString,
      }
    }
    currentData = normalizeWhoamiFlags(currentData)
    localStorage.setItem('whoami', JSON.stringify(currentData))
  } catch (_e) {
    const normalized = normalizeWhoamiFlags(shop as Record<string, unknown>)
    localStorage.setItem('whoami', JSON.stringify(normalized))
    currentData = normalized
  }
  return {
    type: ACTION_TYPES.SET_SHOP,
    payload: currentData as A,
  }
}

export const set_onboarding_shop = (onboarding: boolean) => {
  return {
    type: ACTION_TYPES.SET_BOARDING_SHOP,
    onboarding: onboarding,
    payload: onboarding,
  }
}
export const set_currencies = (currencies: A) => {
  return {
    type: ACTION_TYPES.SET_CURRENCIES,
    currencies: currencies,
  }
}

export const subscription_update = () => {
  return {
    type: ACTION_TYPES.SUBSCRIPTION_UPDATE,
  }
}
